import { Component, Input, OnInit } from '@angular/core';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  
  @Input()
  errorList: IError[] = [];

  
  constructor() { }

  ngOnInit() {
  }

}
